import { get } from 'lodash';

import { intl } from '@shared/localization';

/**
 * The ESB `errorDesc` of a failed request (`error.data.errorDesc`), when it
 * is a non-blank string; `undefined` otherwise.
 */
export function errorDescOf(error: unknown): string | undefined {
  const desc: unknown = get(error, ['data', 'errorDesc']);
  return typeof desc === 'string' && desc.trim() ? desc : undefined;
}

/**
 * Text of a failed ESB request, e.g. for a toast: its `errorDesc`, else the
 * translated generic error.
 */
export function getErrorDesc(error: unknown): string {
  return (
    errorDescOf(error) ?? intl.formatMessage({ id: 'shared.errors.generic' })
  );
}
